import { Component, OnInit } from '@angular/core';

import { Project } from '../project.model';
import { ProjectService } from '../project.service';

@Component({
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.min.css'],
})
export class ProjectListComponent implements OnInit {
    public highlightedProjects: Array<Project>;
    public projects: Array<Array<Project>>;

    public constructor(private projectService: ProjectService) {
    }

    ngOnInit() {
        this.projectService.getProjects().subscribe(projects => {
            this.highlightedProjects = projects.slice(0, 3);
            const interProjects = projects.slice(3);
            this.projects = [];
            for (let i = 0; i < interProjects.length; i += 3) {
                this.projects.push(interProjects.slice(i, i + 3));
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/list/list.component.ts